import { CloseCircle } from "iconsax-reactjs";
import { FC, ReactNode } from "react";
import {
  StyledModal,
  StyledContent,
  StyledHeader,
  StyledCloseButton,
} from "./styled";

type Props = {
  visible: boolean;
  onClose(): void;
  width?: number;
  children?: ReactNode;
  title?: string;
};

const Modal: FC<Props> = ({ visible, onClose, width = 500, children, title }) => {
  if (!visible) return null;

  return (
    <StyledModal onClick={onClose}>
      <StyledContent $width={width} onClick={e => e.stopPropagation()}>
        <StyledHeader $bordered={!!title}>
          <h3>{title}</h3>
          <StyledCloseButton onClick={onClose} aria-label="Close modal">
            <CloseCircle />
          </StyledCloseButton>
        </StyledHeader>
        <div>{children}</div>
      </StyledContent>
    </StyledModal>
  );
};

export default Modal;